import React from 'react';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { STYLE } from 'constants/style';

interface SkippableFieldIndicatorProps {
  show: boolean;
  className?: string;
}

/**
 * Component that displays "**required but skippable" text below form fields
 * that are currently skippable but will become mandatory after consent form
 */
export const SkippableFieldIndicator: React.FC<SkippableFieldIndicatorProps> = ({ show, className }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <span className={`${classes.skippableText} ${className || ''}`}>
      <span className={classes.asterisk}>{t('personalInformation.skippable.asterisk')}</span>
      {t('personalInformation.skippable.requiredButSkippable')}
    </span>
  );
};

const useStyles = makeStyles({
  skippableText: {
    fontSize: '12px',
    fontStyle: 'italic',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT2,
  },
  asterisk: {
    marginRight: '2px',
    color: STYLE.COLOR.WARNING,
  },
});

export default SkippableFieldIndicator;
